import React from 'react';
import { useSite } from '../lib/content';

const DURATIONS = { slow: '60s', normal: '36s', fast: '18s' };

const Marquee = () => {
  const site = useSite();
  const base = Array.isArray(site.marquee) && site.marquee.length ? site.marquee : [''];
  const animated = site.marqueeAnimated !== false; // default: animated
  const duration = DURATIONS[(site.marqueeSpeed || 'normal').toLowerCase()] || DURATIONS.normal;

  // Solid / static — no scrolling, items centered and wrapping.
  if (!animated) {
    return (
      <div className="bg-[#f7f1e3] border-y border-[#942222]/10 py-7" data-testid="marquee-static">
        <div className="max-w-[1400px] mx-auto px-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {base.map((m, i) => (
            <span key={i} className="flex items-center gap-8 font-serif italic text-[#942222] text-2xl md:text-3xl">
              {m}
              {i < base.length - 1 && <span className="text-[#e2b95a]">·</span>}
            </span>
          ))}
        </div>
      </div>
    );
  }

  // Animated — seamless scrolling loop (duplicate items).
  const items = [...base, ...base];
  return (
    <div className="bg-[#f7f1e3] border-y border-[#942222]/10 overflow-hidden py-7" data-testid="marquee-animated">
      <div className="flex gap-12 whitespace-nowrap animate-marquee" style={{ animationDuration: duration }}>
        {items.map((m, i) => (
          <span key={i} className="flex items-center gap-12 font-serif italic text-[#942222] text-2xl md:text-3xl">
            {m}
            <span className="text-[#e2b95a]">·</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
